import { CuttingCustomHole } from './cutting-custom-hole.model';

export class CuttingFastenersSet {
  id: number;
  name: string;
  imageLink: string;
  holes: CuttingCustomHole[];
  type: PositioningTypeEnum;
  asSeparateFastener: boolean;
}

export enum PositioningTypeEnum {
  Free,
  OnSide,
  FreeOnSide,
}
